import { useMediaQuery, useTheme } from '@mui/material';

export function useIsMobile() {
  const theme = useTheme();
  // we have own tailwind config where md represents 768px
  return useMediaQuery(theme.breakpoints.down(768));
}
